enum UserRequestStatus {
  APPROVED = "approved",
  REJECTED = "rejected",
}

export default UserRequestStatus;
